
import Vue from 'vue';
import Button from '@/components/Button/index.vue';
import {
  Wrapper,
  NotificationButtons,
  NotificationIcon,
  NotificationText,
  NotificationType,
} from './styles';

export default Vue.extend({
  name: 'Notification',
  components: {
    Button,
    NotificationButtons,
    NotificationIcon,
    NotificationText,
    Wrapper,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    idTerritory: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
      validator(value: typeof NotificationType[number]) {
        return NotificationType.indexOf(value) !== -1;
      },
    },
    viewed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getIcon() {
      if (this.type === 'info') {
        return 'NotificationInfo';
      }
      if (this.type === 'question') {
        return 'Question';
      }
      return 'Check';
    },
    change() {
      this.$emit('change');
    },
    changeNotAcept() {
      this.$emit('changeNotAcept');
    },
  },
  computed: {
    icon() {
      return () => this.getIcon();
    },
  },
});
